import { render } from "./position.vue?vue&type=template&id=19fd000c&ts=true"
import script from "./position.vue?vue&type=script&lang=ts"
export * from "./position.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__